import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';
import { MW_MW_PDP_SHIFTS } from '../../constants/abTestsConstants.ts';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';

export const usePdpMwLayoutShiftFixTestVariant = (): boolean => {
    const { isPdpMwLayoutShiftFixVariant } = useServerVarsContext();

    return !!isPdpMwLayoutShiftFixVariant;
};

export const trackPdpMwLayoutShiftFixVariant = (): void => {
    trackAbTestV2Variant(MW_MW_PDP_SHIFTS);
};
